

import TableList from "@components/templates/tablelist";
import { mapState, mapGetters } from "vuex";
import {
    HttpGetStorageForecaseList,
    HttpWarehouse,
    HttpStorageCalculate
} from '@/service/storageallocation';
export default {
    mixins: [TableList],
    data () {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    // 'quanbu': 0,
                    // 'IN_orderStatus':null,
                }
            },
            exportdata: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            warehouseList: [],
            startUp: true
        }
    },
    async mounted () {
        await HttpWarehouse().then(res => {
            this.warehouseList = res.data.map(item => {
                return {
                    value: item.id,
                    label: item.title,
                    attach: {
                        ...item
                    }
                }
            })
        }, err => {
            this.$VMessage.error(err.message);
        })
    },
    computed: {
        ...mapGetters("dictionary", [
            "getOrgList",
            "getBillcusorgList",
            "getBillcusAndFbaWareList",
            "getUserManageWarehouseList",
            "getAdminTransferWarehouse"
        ]),
        ToolsData () {
            return [
                {
                    name: "手动测算",
                    operate: "calculate",
                    theme: "warning",
                }, {
                    name: "批量导出",
                    operate: "export",
                    theme: "info",
                    // batch: true,
                }
            ]
        },
        SearchsData () {
            let style = 'width: 130px;';
            return [
                {
                    label: "客户",
                    tag: 'Select',
                    key: 'EQ_organizationId',
                    options: this.getBillcusorgList,
                    show: true,
                    style: style,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: '仓库',
                    tag: 'Select',
                    key: 'EQ_orgWarehouseCode',
                    options: this.getAdminTransferWarehouse,
                    show: true,
                    style: style,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: '日期',
                    tag: 'vDatepicker',
                    key: 'BT_capacityAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    show: true,
                    style: style
                },
            ]
        },
        columns () {
            return [
                {
                    title: '日期',
                    key: 'capacityAt'
                }, {
                    title: '客户',
                    render: (h, { row }) => {
                        let orgName = this.getBillcusorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || '--';
                        if (orgName !== '--') {
                            orgName = orgName.label;
                        }
                        return <div>{orgName}</div>
                    }
                }, {
                    title: '仓库',
                    key: 'orgWarehouseCode'
                }, {
                    title: '总库容',
                    key: 'totalCapacity'
                },
                {
                    title: '期初库容',
                    key: 'originCapacity'
                }, {
                    title: '预计入库',
                    key: 'inboundCapacity'
                }, {
                    title: '预计出库',
                    key: 'outboundCapacity'
                }, {
                    title: '使用库容',
                    key: 'usedCapacity'
                }, {
                    title: '剩余库容',
                    key: 'restCapacity'
                }]
        }
    },
    methods: {
        ajaxRequest: HttpGetStorageForecaseList,
        async handleOperates(params = "", type, batch) {
            switch (type) {
                case 'calculate': {
                    HttpStorageCalculate({
                        contextId: global.SYSID
                    }).then(res => {
                        this.$VMessage.success(res.message);
                        this.startUp++;
                    }, err => {
                        this.$VMessage.error(err.message);
                    })
                    this.$VMessage.success("测算已开始，请稍后查看！");
                    break;
                }
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/capacityCalculate/export', this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'get',
                    })
                    break;
            }
        }
    }
}